export const dots = () => {

    const grid = document.querySelector('.js-dots');
    const dotSize = 1;
    const padding = 60;
    const sizes = [0.25, 0.25, 0.5, 0.5, 0.66, 0.75, 1];

    let animationReq;
    let increment = 0;
    let dots = [];

    let st2;

    var doit;
    var windowWidth = window.innerWidth
    window.addEventListener("resize", function() {
        // Check window width has actually changed and it's not just iOS triggering a resize event on scroll
        if (window.innerWidth != windowWidth) {
            // Update the window width for next time
            windowWidth = window.innerWidth
            // Do stuff here
            createGrid();
            
        }
        // Otherwise do nothing
    })
    
    createGrid();

    function createGrid (event) {
        clearGrid();
        
        //First calculate size of grid canvas: window.innerWidth - (maxDotsize*2);
        //Then calculate the amount of dots to create: 8,12,16,20,24 etc. depending on the width.
        const columns = getComputedStyle(document.documentElement).getPropertyValue('--dots-columns');
        const gridR = grid.getBoundingClientRect();
        const thepadding = gridR.width / columns;
        const width = (gridR.width - (thepadding * 2)) / (thepadding - (dotSize / 2));
        const height = (gridR.height - (thepadding * 2)) / (thepadding - (dotSize / 2));
    
        for	(let i = -1; i < width; i++) {
            for	(let j = -1; j < height; j++) {
                const dot = document.createElement('div');
                dot.className = 'dot';
                dot.style.top = j * thepadding + thepadding + 'px';
                dot.style.left = i * thepadding + thepadding + 'px';
                grid.appendChild(dot);
                dots.push(dot);
            }
        }
        
        animationReq = window.requestAnimationFrame(animateGrid);

    }
    
    function clearGrid () {
        window.cancelAnimationFrame(animationReq);
        // clearTimeout(st1);
        clearTimeout(st2);
        while (grid.firstChild) { grid.removeChild(grid.firstChild); }
        dots = [];
    }
    
    function animateGrid () {
        const dot = dots[Math.floor(Math.random() * dots.length)];
        const scale = sizes[Math.floor(Math.random() * sizes.length)];
        // const timeoutTime = Math.floor(Math.random() * (5000 - 10 + 1)) + 10;

        dot.style.transform =  `scale(${scale})`;
        const st1 = setTimeout(() =>{
            dot.style.transform = `scale(.025)`;
            clearTimeout(st1);
        }, 2000);
        

        st2 = setTimeout(() =>{
            animationReq = window.requestAnimationFrame(animateGrid)
            clearTimeout(st2);
        }, 800);

    }

    // const checkpoint =  window.innerHeight / 100 * 87.5;
    // var opacity;
    // window.addEventListener('scroll', fadeDots);

    // function fadeDots() {
    //     const currentScroll = window.pageYOffset;
    //     if (currentScroll <= checkpoint) {
    //         opacity = 1 - currentScroll / checkpoint;
    //     } else {
    //         opacity = 0;
    //     }
    //     grid.style.opacity = opacity;
    // }

};
  